import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  showLoader: boolean = false;

  constructor() { }
  
  displayLoader() {
    this.showLoader = true;
  }

  hideLoader() {
    this.showLoader = false;
  }

}
